import createBrowserHistory from 'history/createBrowserHistory';
import { RouterStore, syncHistoryWithStore } from 'mobx-react-router';

export function initRoutingHistory() {
  const browserHistory = createBrowserHistory();

  const routingStore = new RouterStore();

  // Enhanced history object with additional subscribe and unsubscribe methods
  // https://github.com/IBM/mobx-react-router#synchistorywithstorehistory-store
  const history = syncHistoryWithStore(browserHistory, routingStore);

  // TODO: routingStore needs to be exposed because it's used via root context in frontend-web
  // we should stop doing that and use the useHistory hook instead
  return { history, routingStore };
}
